import React, {useEffect, useState} from "react";
import ReactTable from "react-table-v6"
import { DeleteOutline, AddCircle, Edit } from '@mui/icons-material';
import { IconButton, Checkbox } from '@material-ui/core';
import { Tooltip } from '@material-ui/core';
import { useConfirm } from 'material-ui-confirm';
import { getCVTData } from '../../services/TimeSeriesService'
import PointModal from "../PointModal"
import 'react-table-v6/react-table.css'

const PointList = (props) => {
    const [data, setData] = useState();
    const [points, setPoints] = useState();
    let [openModal, setOpenModal] = useState(false);
    const [selectedPoint, setSelectedPoint] = useState();

    const [allTypes, setAllTypes] = useState()
    const [allUnits, setAllUnits] = useState()

    const confirm = useConfirm();

    useEffect(() => {
        setPoints(props.points)
    }, [props.points])

    useEffect(() => {
        props.getAllBrickTypes().then(response => {
            setAllTypes(response)
        })
    },[props.getAllBrickTypes])

    useEffect(() => {
        props.getAllUnits().then(response => {
            setAllUnits(response)
        })
    },[props.getAllUnits])

    useEffect(()=> {
        if (props.equipment && props.points && !data) {
            var yesterday = new Date();
            yesterday.setHours(-1)

            getCVTData(props.equipment.site.site_id, props.equipment.equipment_id).then(response => {
                setData(response);
            })
        }
    }, [props.equipment, props.points])

    const deletePoint = (point) => {
		confirm({ 
			title: "Delete this point?",
			description: 'This action deletes the point from the equipment.  You will no longer be able to query data for the point.' 
		})
		.then(() => { 
			props.deletePointCallback(point)
		})
		.catch(() => {console.log("User cancelled action") });
	}

    const columns = [
        {
            Header: 'Name',
            accessor: 'name',
            Cell: p => {
                let nameParts = p.value.split("_");
                let name = "";
                nameParts.forEach(p => {
                    let part = p.substring(0, 1).toUpperCase() + p.substring(1, p.length)
                    name += (name.length > 0 ? " " + part : part) 
                })

                return name;
            }
        },
        {
            Header: 'Type',
            accessor: 'type',
            Cell: p => {
                let t = allTypes ? allTypes.find(t => t.brick_point_type === p.value) : null
                return t ? t.name : p.value
            }
        },
        {
            Header: 'Current Value',
            accessor: 'timeSeriesConnection',
            getProps: (state, rowInfo, column) => {
                let point_value = data.find(v => v.point_uuid == rowInfo.row.timeSeriesConnection.uuid)
                let date = new Date(point_value.time + "Z"); 
                let dayAgo = new Date(Date.now() - (24 * 60 * 60 * 1000))
                let hourAgo = new Date(Date.now() - (60 * 60 * 1000))

                if (date < dayAgo)  // Stale data, show date and time
                {
                    return { style: { color: 'red'} }
                } 
 
                if (date < hourAgo) // Recently stale date
                {
                    return { style: { color: 'yellow'} }
                }

                return ""
            },
            Cell: p => {
                let point_value = data.find(v => v.point_uuid == p.value.uuid)
                if (point_value) {
                    let u = allUnits ? allUnits.find(u => u.brick_unit === p.original.units) : null
                    let units = u ? u.name : ""
                    return data && (Math.round(point_value.value * 10) / 10 + " " + units + " " + point_value.quality)
                } else {
                    return "-"
                }
            } 
        },
        {
            Header: 'Quality',
            accessor: 'timeSeriesConnection',
            getProps: (state, rowInfo, column) => {
                return { style: { color: 'red'} }
            },
            Cell: p => {
                let point_value = data.find(v => v.point_uuid == p.value.uuid)
                if (point_value) {
                    return data && point_value.quality
                } else {
                    return ""
                }
            } 
        },
        {
            Header: 'Timestamp',
            accessor: 'timeSeriesConnection',
            Cell: p => {
                let point_value = data.find(v => v.point_uuid == p.value.uuid)

                if (!point_value || !point_value.time) // No entry in CVT
                    return "-"

                let date = new Date(point_value.time + "Z"); 
                let dayAgo = new Date(Date.now() - (24 * 60 * 60 * 1000))
                let hourAgo = new Date(Date.now() - (60 * 60 * 1000))

                if (date < hourAgo)  // Stale data, show date and time
                    return date.toLocaleString('en-US'); 

                return date.toLocaleTimeString('en-US');  // Just show current time
            }
        },
        {
            Header: 'Active',
            accessor: 'is_active',
            Cell: p => {
                return <Tooltip title="Is Active">
                        <Checkbox
                            variant="contained"
                            color="primary"
                            aria-label={"Is Active"}
                            size={"small"}
                            checked={p.value}
                            disabled
                        >
                        </Checkbox>
                    </Tooltip>
            },
            width: 75
        },
        {
            Header: 'Graphed',
            accessor: 'is_graphed',
            Cell: p => {
                return <Tooltip title="Is Graphed">
                        <Checkbox
                            variant="contained"
                            color="primary"
                            aria-label={"Is Graphed"}
                            size={"small"}
                            checked={p.value}
                            disabled
                        >
                        </Checkbox>
                    </Tooltip>
            },
            width: 75
        },
        {
            Header: '',
            accessor: 'id',
            Cell: p => {
                return <Tooltip title="Edit">
                    <IconButton
                        variant="contained"
                        color="primary"
                        aria-label={"Edit Point" }
                        size={"small"}
                        onClick={() => {
                            setSelectedPoint(p.original)
                            setOpenModal(true)
                        }}>
                        <Edit />
                </IconButton>
            </Tooltip>
            },
            width:50,
        },
        {
            Header: '',
            accessor: 'id',
            Cell: p => {
                return <Tooltip title="Delete point">
                        <IconButton
                            variant="contained"
                            color="primary"
                            aria-label={"Delete point" }
                            size={"small"}
                            onClick={() => {
                                deletePoint(p.original)
                          }}
                          >
                            <DeleteOutline style={{color: "#FF4438"}} />
                        </IconButton>
                    </Tooltip>
            },
            width: 50,
            show: props.deletePointCallback != null
        },
    ]
        if (!data) {
            return null
        }

        return (
            <div className="space-list">
                <PointModal
                    open={openModal}
                    equipmentId={props.equipment && props.equipment.equipment_id}
                    selectedPoint={selectedPoint}
                    addOrUpdatePointCallback={props.addOrUpdatePointCallback}
                    brickTypes={allTypes} 
                    allUnits={allUnits}
                    closeCallback={() => {
                        setOpenModal(false);
                    }}
                />
                <div className="space-add-mode">
                    {points && points.length ? (
                        <Tooltip title="Add Point">
                            <IconButton
                                variant="contained"
                                color="primary"
                                aria-label={'Add Point'}
                                onClick={() => {
                                    setSelectedPoint(null)
                                    setOpenModal(true);
                                }}
                            >
                                <AddCircle
                                    style={{
                                        fill: '#00b088',
                                        background: 'white',
                                        transform: 'scale(1.0)',
                                    }}
                                />
                            </IconButton>
                        </Tooltip>
                    ) : null}
                </div>
                <div className="section-header">Equipment Data Points</div>
                {points && points.length ? 
                    <div className="point-list-table">
                        <ReactTable key={(props.points && props.points.length) || 0}
                            data={props.points || []}
                            columns={columns}
                            minRows={0}
                            /*
                            getTdProps={(state, rowInfo, column, instance) => {
                                return {
                                  onClick: (e, handleOriginal) => {
                                    if (column.id !== "id") {
                                        setSelectedPoint(rowInfo.original)
                                        setOpenModal(true)
                                    }
                                  }
                                }
                              }}
                              */
                        />
                    </div> 
                : (
                    <div className="bulk_add_prompt">
                        <IconButton
                            variant="contained"
                            color="primary"
                            aria-label={'Add Point'}
                            onClick={() => {
                                setOpenModal(true);
                            }}
                        >
                            <AddCircle style={{ fill: '#00b088', background: 'white' }} />
                        </IconButton>
                        There are currently no points configured. Add some now!
                    </div>
                )}  
            </div>
        )
}

export default PointList;
